/* ───────────────────── DATE / MONTH HELPERS ───────────────────── */
export const MONTH_NAMES = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const MONTHS_TO_SHOW = 3;

export function buildMonth(year, month) {
  return {
    name: MONTH_NAMES[month],
    year,
    month,
    days: new Date(year, month + 1, 0).getDate(),
  };
}

export function getDefaultStartMonth() {
  const now = new Date();
  return { year: now.getFullYear(), month: now.getMonth() };
}

export function getTeamStartMonth(team) {
  if (team.seasonStartMonth !== undefined && team.seasonStartYear !== undefined) {
    return { year: team.seasonStartYear, month: team.seasonStartMonth };
  }
  return getDefaultStartMonth();
}

export function getTeamMonthCount(team) {
  if (team.seasonStartMonth !== undefined && team.seasonEndMonth !== undefined &&
      team.seasonStartYear !== undefined && team.seasonEndYear !== undefined) {
    return (team.seasonEndYear - team.seasonStartYear) * 12 +
      (team.seasonEndMonth - team.seasonStartMonth) + 1;
  }
  return MONTHS_TO_SHOW;
}

export function getMonthsFrom(startYear, startMonth, count = MONTHS_TO_SHOW) {
  const months = [];
  let y = startYear, m = startMonth;
  for (let i = 0; i < count; i++) {
    months.push(buildMonth(y, m));
    m++;
    if (m > 11) { m = 0; y++; }
  }
  return months;
}

export function shiftMonth(year, month, delta) {
  let m = month + delta;
  let y = year;
  while (m > 11) { m -= 12; y++; }
  while (m < 0) { m += 12; y--; }
  return { year: y, month: m };
}
